import axios from "../config/axiosInstance";
import { FILIAL } from "../config/apiConfig";

// Empresas/filiais SEMPRE em ordem alfabética (pt-BR; sem diferenciar acento ou
// caixa; números pela grandeza: "Filial 2" antes de "Filial 10"). A chave é o
// nome exibido (nome fantasia quando houver). O backend já entrega ordenado; isto
// garante a ordem na tela mesmo se a lista vier de outra origem ou for montada
// no cliente.
export const companyDisplayName = (company) =>
  company?.fantasyName || company?.name || "";

export const sortCompaniesAlphabetically = (list) =>
  Array.isArray(list)
    ? [...list].sort((a, b) =>
        companyDisplayName(a).localeCompare(companyDisplayName(b), "pt-BR", {
          sensitivity: "base",
          numeric: true,
        }),
      )
    : [];

// Troca a empresa ativa: pede um token novo e recarrega a página (todo o estado
// em memória é da empresa anterior). Rejeita com o erro da API para quem chamou
// poder avisar o usuário.
export const switchActiveCompany = async (targetId) => {
  const { data } = await axios.post(FILIAL.SWITCH(targetId));
  localStorage.setItem("token", data.token);
  window.location.reload();
};

export const describeSwitchCompanyError = (error) => {
  const message = error?.response?.data?.message;
  if (message) return String(message);
  if (error?.response?.status === 403) {
    return "Você não tem acesso a essa empresa.";
  }
  return "Não foi possível trocar de empresa. Tente novamente.";
};
